import { RouterProvider } from 'react-router';
import { ThemeCustomization, Snackbar, Notistack, ScrollTop } from '@trendiolive/trendio-selfcare-ui-kit';
import Locales from 'components/Locales';
import PickersThemeProvider from 'components/PickersThemeProvider';
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import router from 'routes';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <PickersThemeProvider>
        <Locales>
          <ScrollTop>
            <Notistack>
              <AuthProvider>
                <>
                  <RouterProvider router={router()} />
                  <Snackbar />
                </>
              </AuthProvider>
            </Notistack>
          </ScrollTop>
        </Locales>
      </PickersThemeProvider>
    </ThemeCustomization>
  );
}
